import { Button, Col, Container, Row } from 'react-bootstrap';
import video from './Coldwell Banker _ Preferred Real Estate Consultants in Egypt.mp4';
import Slider from './slider/Slider';
import Projucts from './projucts/Projucts';
import { Fade } from 'react-awesome-reveal';
import './home.css';
function Home(){
    return(
        <>
        <Fade direction='left' >
        <header>
            <Container fluid>
                <video src={video} width="100%" muted autoPlay loop></video>
                    <Row className='header-main' style={{textAlign:'center'}}>
                        {/* <h4>
                        GUIDING YOU HOME FOR MORE THAN
                        </h4> */}
                        <h2>
                        let us help you make the move
                        </h2>
                        <Col lg={12}>
                            <div className='btn-d'>
                                <input style={{width:'70%',border:'none',borderRadius:'5px 0 0 20px',padding:'0 20px'}}  type='text' placeholder='Search By Project Name'></input>    
                                <Button style={{width:'30%',border:'none',borderRadius:'0 30px 30px 0',fontWeight:'700'}}>Search</Button>
                            </div>
                        </Col>
                        <Col style={{display:'flex', justifyContent:'center',marginTop:'20px'}}>
                            <Button style={{borderRadius:'20px 0 0 20px', marginRight:'20px',fontWeight:'700'}}>Get a Consultant</Button>
                            <Button style={{borderRadius:'0 20px 20px 0',fontWeight:'700'}}>Buy a Home</Button>
                        </Col>
                    </Row>
            </Container>
        </header>
        <Slider />
        <Projucts />
        </Fade>
        </> 
    )
}
export default Home;